import React, { useEffect, useRef, useState } from 'react';
import WaveSurfer from 'wavesurfer.js';

const WaveSurferPlayer = ({ audioUrl }) => {
  const waveformRef = useRef(null);
  const wavesurferRef = useRef(null);
  const [style, setStyle] = useState({ right: '266px', top: '28px', position: 'absolute' });
  const [visible, setVisible] = useState(true);

  // Gestione responsive dinamica
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setStyle({ right: '28px', bottom: '-4px', position: 'absolute' });
      } else if (width < 992) {
        setStyle({ right: '28px', bottom: '-4px', position: 'absolute' });
      } else {
        setStyle({ right: '266px', top: '28px', position: 'absolute' });
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Inizializzazione wavesurfer
  useEffect(() => {
    setVisible(true); // assicura visibilità

    if (wavesurferRef.current) {
      wavesurferRef.current.destroy();
    }

    const wavesurfer = WaveSurfer.create({
      container: waveformRef.current,
      waveColor: '#ddd',
      progressColor: '#0d6efd',
      height: 30,
      width: 200,
      responsive: true,
    });

    wavesurferRef.current = wavesurfer;
    wavesurfer.load(audioUrl);

    wavesurfer.on('ready', () => {
      wavesurfer.play();
    });

    wavesurfer.on('finish', () => {
      setVisible(false); // nasconde alla fine
    });

    return () => {
      if (wavesurferRef.current) {
        try {
          wavesurferRef.current.destroy();
        } catch (e) {
          console.warn('Errore distruzione wavesurfer:', e);
        }
      }
    };
  }, [audioUrl]);

  if (!visible) return null;

  return (
    <div className="mt-2" style={style}>
      <div ref={waveformRef} style={{ width: '250px', minWidth: '150px' }} />
    </div>
  );
};

export default WaveSurferPlayer;
